<template>
  <div class="devices">
    <header-mobile-page label="Manage Installs" />
    <device-list />
  </div>
</template>

<script>
  import DeviceList from '@/components/Common/InstalledDevices/InstalledDevicesList.vue'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  export default {
    components: {
      DeviceList,
      HeaderMobilePage
    }
  }
</script>

<style lang="scss" scoped>
  .devices {
    width: 100%;
    height: auto;

    padding: 0 20px 10px 20px;
  }
</style>